export default "__VITE_ASSET__D1OJeCr2__"